angular.module('picmonic-common').component('testimonialBlock', {
  templateUrl: '/templates/common/components/testimonial-block/testimonial-block.html',
  bindings: {
    marketId: '<',
  },
});
